import 'vuetify/styles';
import { ThemeDefinition, createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const customLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#415363',
    secondary: '#4D9CB9',
    agencyRed: '#DF2726',
    accent: '#777',
    error: '#E7403B',
    warning: '#FC9307',
    info: '#04AFC5',
    success: '#4DA852',
    border: '#e7e7e7',
    offwhite: '#f5f5f5',
    gray: '#717171',
    text: '#2a2a2a',
    scale1: '#66BF7C',
    scale2: '#7AC57D',
    scale3: '#BAD780',
    scale4: '#FEE382',
    scale5: '#FBB379',
    scaleGray: '#bababa',
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'customLightTheme',
    themes: {
      customLightTheme,
    },
  },
});
